export const taglineSx = {
  fontWeight: 700,
};
